import { ReactComponent as TickIcon } from '@crazyegginc/hatch/dist/images/icon-tick-basic.svg';

export function ProgressTracker({ currentStep, totalSteps, hasError = false }) {
  return (
    <div className="flex items-center justify-center">
      {Array.from({ length: totalSteps }, (_, index) => {
        const stepNumber = index + 1;
        const isCompleted = stepNumber < currentStep;
        const isCurrent = stepNumber === currentStep;
        const isLastStep = stepNumber === totalSteps;
        const showTick = isCompleted || (isCurrent && !hasError);

        return (
          <div key={index} className="flex items-center">
            <div
              className={`w-4 h-4 sm:w-6 sm:h-6 rounded-full flex items-center justify-center text-white ${
                isCurrent && hasError ? 'bg-carnation-500' : 'bg-dodger-blue-500'
              }`}
            >
              {showTick ? (
                <TickIcon className="w-2 h-2 sm:w-3 sm:h-3 text-white fill-current" />
              ) : (
                <span className="w-[10px] h-[10px] sm:w-[18px] sm:h-[18px] bg-white rounded-full"></span>
              )}
            </div>
            {!isLastStep && <div className="w-[50px] h-0.5 mx-1 bg-dodger-blue-500 rounded-full" />}
          </div>
        );
      })}
    </div>
  );
}
